import { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toPng } from "html-to-image";
import { Loader2, Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SiteHeader } from "@/components/SiteHeader";
import { Footer } from "@/components/BusinessSection";
import { HuntCardView } from "@/components/HuntCardView";

export default function HuntCardPage() {
  const { cardId } = useParams();
  const [card, setCard] = useState(null);
  const [state, setState] = useState("loading");
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    api.publicHuntCard(cardId).then((d) => { setCard(d.card); setState("ok"); }).catch(() => setState("notfound"));
  }, [cardId]);

  const download = async () => {
    if (!ref.current) return;
    setBusy(true);
    try {
      const url = await toPng(ref.current, { pixelRatio: 2, backgroundColor: "#1a1a17", skipFonts: true });
      const a = document.createElement("a"); a.download = "homerange-hunt-card.png"; a.href = url; a.click();
    } catch { toast.error("Couldn't generate image."); }
    setBusy(false);
  };

  return (
    <div className="bg-charcoal min-h-screen grain text-bone" data-testid="public-hunt-card-page">
      <SiteHeader />
      <main className="max-w-lg mx-auto px-5 py-12">
        {state === "loading" && <div className="py-24 grid place-items-center"><Loader2 className="animate-spin text-blaze" /></div>}
        {state === "notfound" && (
          <div className="text-center py-24" data-testid="card-notfound">
            <h1 className="font-serif text-3xl">This hunt card isn&apos;t available</h1>
            <p className="text-bone/50 mt-3">It may be private or no longer shared.</p>
            <Link to="/" className="mt-6 inline-block bg-blaze text-white px-6 py-3 rounded-full text-sm font-semibold">Explore HomeRange</Link>
          </div>
        )}
        {state === "ok" && (
          <>
            <HuntCardView ref={ref} card={card} />
            <div className="mt-6 flex items-center justify-center gap-3">
              <button onClick={download} disabled={busy} className="inline-flex items-center gap-2 bg-blaze text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-blaze-light transition-colors disabled:opacity-50" data-testid="card-download">{busy ? <Loader2 size={15} className="animate-spin" /> : <Download size={15} />} Download</button>
              <Link to="/" className="text-sm text-bone/60 hover:text-bone transition-colors">What&apos;s HomeRange?</Link>
            </div>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
